var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPasswordHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x33_2x32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-560 220 32 32",
    style: {
      enableBackground: "new -560 220 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#AFB3BA;stroke-width:1.2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON-hide"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_125_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_129_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    className: "st0",
    d: "M-544,243.2c-5.2,0-8.8-3.7-10.5-7.2c1.7-3.6,5.2-7.2,10.5-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    className: "st0",
    d: "M-544,243.2c5.2,0,8.8-3.7,10.5-7.2c-1.7-3.6-5.2-7.2-10.5-7.2"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_126_",
    className: "st0",
    cx: -544,
    cy: 236,
    r: 4.1
  })), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_168_",
    className: "st0",
    x1: -537.9,
    y1: 225.8,
    x2: -550.1,
    y2: 246.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordHide);
export default __webpack_public_path__ + "static/media/ICON-password-hide.8a68f5e7db82d9615ac4ca4ccf71c56b.svg";
export { ForwardRef as ReactComponent };